export type TableColumnLike = {
  columnKey?: string;
};

export const buildCellStyle = <TRow>(
  resolver: (
    row: TRow,
    column: TableColumnLike
  ) => {
    highlight: boolean;
    color: string;
  } | null
) => {
  return ({ row, column }: { row: TRow; column: TableColumnLike }) => {
    const resolved = resolver(row, column);
    if (!resolved) return {};

    return {
      padding: '0',
      backgroundColor: resolved.highlight ? resolved.color : ''
    };
  };
};
